/**
 * Auth Module Constants
 *
 * Constantes centralizadas para o módulo de autenticação
 */

// Validation Rules
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 50;
export const VERIFICATION_CODE_LENGTH = 6;

// Timers (in seconds)
export const RESEND_COOLDOWN_SECONDS = 30;
export const REDIRECT_COUNTDOWN_SECONDS = 3;

// Colors (Design System)
export const COLORS = {
  primary: '#F4CC04',
  background: {
    dark: '#0a0a0a',
    darkSecondary: '#1a1a1a',
    card: '#2a2a2a',
  },
  text: {
    white: '#FFFFFF',
    gray: '#CCCCCC',
    darkGray: '#888888',
  },
  error: '#e53935',
  warning: '#ff9800',
  success: '#4CAF50',
  border: '#333333',
} as const;

// Routes
export const AUTH_ROUTES = {
  login: '/',
  register: '/cadastro',
  forgotPassword: '/esqueci-senha',
  verifyEmail: '/verify-email',
  chat: '/chat',
} as const;

// Storage Keys
export const STORAGE_KEYS = {
  pendingVerificationEmail: 'pendingVerificationEmail',
  sidebarState: 'sidebarState',
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  emailRequired: 'E-mail é obrigatório',
  emailInvalid: 'E-mail inválido',
  passwordRequired: 'Senha é obrigatória',
  passwordTooShort: `Senha deve ter no mínimo ${PASSWORD_MIN_LENGTH} caracteres`,
  passwordMissingUppercase: 'Senha deve conter pelo menos uma letra maiúscula',
  passwordMissingLowercase: 'Senha deve conter pelo menos uma letra minúscula',
  passwordMissingNumber: 'Senha deve conter pelo menos um número',
  passwordMissingSpecial: 'Senha deve conter pelo menos um caractere especial',
  passwordsDoNotMatch: 'As senhas não coincidem',
  nameRequired: 'Nome é obrigatório',
  phoneRequired: 'Telefone é obrigatório',
  phoneInvalid: 'Telefone inválido',
  genericAuth: 'Erro de autenticação',
  emailNotVerified: 'Email não verificado',
} as const;
